if (!customElements.get("product-info")) {
  customElements.define(
    "product-info",
    class ProductInfo extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        window.addEventListener('variant:changed', (event) => {
          this.updateMedia(event.detail.variant);
        });
      }

      updateMedia(variant) {
        if (!variant) return;
        
        const mediaGallery = document.querySelector('.product__media-gallery');
        if (!mediaGallery) return;

        // バリエーションに関連付けられた画像がない場合は何もしない
        if (!variant.featured_media) return;

        // バリエーションに関連付けられた画像のIDを取得
        const mediaId = variant.featured_media.id.toString();
        
        // そのIDを持つメディアアイテムをアクティブにする
        this.setActiveMedia(mediaId);
      }

      setActiveMedia(mediaId) {
        const mediaGallery = document.querySelector('.product__media-gallery');
        if (!mediaGallery) return;

        const mediaItems = Array.from(mediaGallery.querySelectorAll('.product__media-item'));
        const activeItem = mediaItems.find(item => item.dataset.mediaId === mediaId);
        
        if (!activeItem) return;

        // すべてのメディアアイテムから active クラスを削除
        mediaItems.forEach(item => {
          item.classList.remove('is-active');
        });

        // アクティブなメディアアイテムに active クラスを追加
        activeItem.classList.add('is-active');

        // サムネイルも更新
        const thumbnails = Array.from(mediaGallery.querySelectorAll('.product__media-thumbnail'));
        thumbnails.forEach(thumbnail => {
          thumbnail.classList.remove('is-active');
          if (thumbnail.dataset.mediaId === mediaId) {
            thumbnail.classList.add('is-active');
          }
        });
      }
    }
  );
}
